import { Component, inject } from '@angular/core'
import { Navbar } from '../../common/navbar/navbar.component'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { ClassService } from '../../../services/class.service'
import { Timeslot, Venue } from '../../../modal/class.modal'
import { commonUtil } from '../../../utils/common.util'

@Component({
  selector: 'app-availability',
  imports: [Navbar, TranslatePipe],
  templateUrl: './availability.component.html',
  styleUrl: './availability.component.css'
})
export class Availability {
  private classService = inject(ClassService)
  private translateService = inject(TranslateService)
  venueTimeslots: Venue[] = []
  selecteVenues: Venue[] = []
  isVenueLoading = true
  isUserVenueLoading = true
  isUpdating = false

  constructor() {
    this.getData()
  }

  getData() {
    this.isVenueLoading = true
    this.isUserVenueLoading = true
    this.classService.getUserVenueTimeslots().subscribe({
      next: (venues) => {
        this.venueTimeslots = venues
        this.isVenueLoading = false
      },
      error: () => (this.isVenueLoading = false)
    })
    this.classService.getUserPreferVenueTimeslots().subscribe({
      next: (venues) => {
        this.selecteVenues = venues
        this.isUserVenueLoading = false
      },
      error: () => (this.isUserVenueLoading = false)
    })
  }

  isPreferTimeslot(slot: Timeslot) {
    return this.selecteVenues.some((v) =>
      v.timeslots.some((ts) => ts.slots.some((_slot) => _slot.id === slot.id))
    )
  }

  doCheckTimeslot(event: Event, venue: Venue, slot: Timeslot) {
    let checked = (event.target as HTMLInputElement).checked
    let seleVenue = this.selecteVenues.find((v) => v.id === venue.id)
    let seleTimeslot = seleVenue?.timeslots.find(
      (ts) => ts.weekday === slot.weekday
    )

    if (!checked) {
      seleTimeslot?.slots.splice(
        seleTimeslot.slots.findIndex((s) => s.id === slot.id),
        1
      )

      if (seleTimeslot?.slots.length === 0) {
        seleVenue?.timeslots.splice(
          seleVenue.timeslots.findIndex((ts) => ts.weekday === slot.weekday),
          1
        )
      }

      if (seleVenue?.timeslots.length === 0) {
        this.selecteVenues.splice(
          this.selecteVenues.findIndex((v) => v.id === seleVenue?.id),
          1
        )
      }
      return
    }

    if (!seleVenue) {
      seleVenue = {
        ...venue,
        timeslots: []
      }
      this.selecteVenues.push(seleVenue)
    }

    if (!seleTimeslot) {
      seleTimeslot = {
        weekday: slot.weekday!,
        slots: []
      }
      seleVenue.timeslots.push(seleTimeslot)
    }

    seleTimeslot.slots.push({
      ...slot
    })

    seleTimeslot.slots.sort(
      (a, b) => Number.parseInt(a.start!) - Number.parseInt(b.start!)
    )
    seleVenue.timeslots.sort((a, b) => (a.weekday % 7) - (b.weekday % 7))
  }

  doSubmit() {
    let seleIds = this.selecteVenues
      .flatMap((v) => v.timeslots)
      .flatMap((slots) => slots.slots)
      .map((slot) => slot.id!)
    if (seleIds.length === 0) {
      return
    }
    this.isUpdating = true
    this.classService.updateUserPreferTimeslots(seleIds).subscribe({
      next: (success) => {
        if (success) {
          commonUtil.alert(
            this.translateService.instant(
              'app.availability.timeslotUpdateSuccessfully'
            ),
            'success'
          )
          this.isUpdating = false
        }
      },
      error: () => (this.isUpdating = false)
    })
  }
}
